import { Stack } from '@fluentui/react';
import React, { useContext, useEffect, useState } from 'react';
import styles from '../styles/collectie.module.scss';
import MainCarouselComponent, { TCarouselItem, TcarouselListItem } from './mainCarouselComponent';
import GlobalContext from '../_contexts/GlobalContext';

export interface IWelcomeComponentProps {

}

const WelcomeComponent: React.FunctionComponent<IWelcomeComponentProps> = (props: IWelcomeComponentProps) => {
    const [carouselList, setcarouselList] = useState<TcarouselListItem[]>([]);

    const { PageWidth } = useContext(GlobalContext);

    useEffect(() => {
        setcarouselList(getCarouselItems());
    }, []);

    const getCarouselItems = (): TcarouselListItem[] => {
        let carouselList: TcarouselListItem[] = [];

        let carouselitems: TCarouselItem[] = [];
        carouselitems.push({
            content: <div onClick={() => { }} style={{ cursor: "pointer" }}>
                <div style={{ width: PageWidth, maxWidth: PageWidth, minHeight: 300, backgroundSize: "contain", backgroundImage: `url(${process.env.PUBLIC_URL}/assets/soldering.webp?v=1)` }} className={styles.mainSelectedSetLogo} />
            </div>

        });
        carouselitems.push({
            content: <div onClick={() => { }} style={{ cursor: "pointer" }}>
                <div style={{ width: PageWidth, maxWidth: PageWidth, minHeight: 300, backgroundSize: "contain", backgroundImage: `url(${process.env.PUBLIC_URL}/assets/picofly.png?v=1)` }} className={styles.mainSelectedSetLogo} />
            </div>

        });
        carouselitems.push({
            content: <div onClick={() => { }} style={{ cursor: "pointer" }}>
                <div style={{ width: PageWidth, maxWidth: PageWidth, minHeight: 300, backgroundSize: "contain", backgroundImage: `url(${process.env.PUBLIC_URL}/assets/switches.jpg?v=1)` }} className={styles.mainSelectedSetLogo} />
            </div>

        });

        carouselList.push({id:"0001", price:90, title:"Uw switch laten ombouwen", subtitle: "Installeren van een Picochip in uw Switch. Extra opties te koop:	", items: carouselitems});

        carouselitems = [];
        carouselitems.push({
            content: <div onClick={() => { }} style={{ cursor: "pointer" }}>
                <div style={{ width: PageWidth, maxWidth: PageWidth, minHeight: 300, backgroundSize: "contain", backgroundImage: `url(${process.env.PUBLIC_URL}/assets/Products/1/1.webp?v=1)` }} className={styles.mainSelectedSetLogo} />
            </div>

        });
        carouselitems.push({
            content: <div onClick={() => { }} style={{ cursor: "pointer" }}>
                <div style={{ width: PageWidth, maxWidth: PageWidth, minHeight: 300, backgroundSize: "contain", backgroundImage: `url(${process.env.PUBLIC_URL}/assets/Products/1/2.webp?v=1)` }} className={styles.mainSelectedSetLogo} />
            </div>

        });
        carouselitems.push({
            content: <div onClick={() => { }} style={{ cursor: "pointer" }}>
                <div style={{ width: PageWidth, maxWidth: PageWidth, minHeight: 300, backgroundSize: "contain", backgroundImage: `url(${process.env.PUBLIC_URL}/assets/Products/1/3.webp?v=1)` }} className={styles.mainSelectedSetLogo} />
            </div>

        });

        carouselList.push({id:"0002", price:140, title: "Nintendo Switch met Picofly MOD chip", subtitle: "Koop wat u ziet op de foto's of stuur me een bericht met de opties die u wenst:	", items: carouselitems});

        carouselitems = [];
        carouselitems.push({
            content: <div onClick={() => { }} style={{ cursor: "pointer" }}>
                <div style={{ width: PageWidth, maxWidth: PageWidth, minHeight: 300, backgroundSize: "contain", backgroundImage: `url(${process.env.PUBLIC_URL}/assets/Products/2/1.webp?v=1)` }} className={styles.mainSelectedSetLogo} />
            </div>

        });
        carouselitems.push({
            content: <div onClick={() => { }} style={{ cursor: "pointer" }}>
                <div style={{ width: PageWidth, maxWidth: PageWidth, minHeight: 300, backgroundSize: "contain", backgroundImage: `url(${process.env.PUBLIC_URL}/assets/Products/2/2.webp?v=1)` }} className={styles.mainSelectedSetLogo} />
            </div>

        });
        carouselitems.push({
            content: <div onClick={() => { }} style={{ cursor: "pointer" }}>
                <div style={{ width: PageWidth, maxWidth: PageWidth, minHeight: 300, backgroundSize: "contain", backgroundImage: `url(${process.env.PUBLIC_URL}/assets/Products/2/3.webp?v=1)` }} className={styles.mainSelectedSetLogo} />
            </div>

        });
        carouselitems.push({
            content: <div onClick={() => { }} style={{ cursor: "pointer" }}>
                <div style={{ width: PageWidth, maxWidth: PageWidth, minHeight: 300, backgroundSize: "contain", backgroundImage: `url(${process.env.PUBLIC_URL}/assets/Products/2/4.webp?v=1)` }} className={styles.mainSelectedSetLogo} />
            </div>

        });

        carouselList.push({id:"0003", price:175, title: "Nintendo Switch met Picofly MOD chip", subtitle: "Koop wat u ziet op de foto's of stuur me een bericht met de opties die u wenst:	", items: carouselitems});

        carouselitems = [];
        carouselitems.push({
            content: <div onClick={() => { }} style={{ cursor: "pointer" }}>
                <div style={{ width: PageWidth, maxWidth: PageWidth, minHeight: 300, backgroundSize: "contain", backgroundImage: `url(${process.env.PUBLIC_URL}/assets/Products/3/1.webp?v=1)` }} className={styles.mainSelectedSetLogo} />
            </div>

        });
        carouselitems.push({
            content: <div onClick={() => { }} style={{ cursor: "pointer" }}>
                <div style={{ width: PageWidth, maxWidth: PageWidth, minHeight: 300, backgroundSize: "contain", backgroundImage: `url(${process.env.PUBLIC_URL}/assets/Products/3/2.webp?v=1)` }} className={styles.mainSelectedSetLogo} />
            </div>

        });
        carouselitems.push({
            content: <div onClick={() => { }} style={{ cursor: "pointer" }}>
                <div style={{ width: PageWidth, maxWidth: PageWidth, minHeight: 300, backgroundSize: "contain", backgroundImage: `url(${process.env.PUBLIC_URL}/assets/Products/3/3.webp?v=1)` }} className={styles.mainSelectedSetLogo} />
            </div>

        });
        carouselitems.push({
            content: <div onClick={() => { }} style={{ cursor: "pointer" }}>
                <div style={{ width: PageWidth, maxWidth: PageWidth, minHeight: 300, backgroundSize: "contain", backgroundImage: `url(${process.env.PUBLIC_URL}/assets/Products/3/4.webp?v=1)` }} className={styles.mainSelectedSetLogo} />
            </div>

        });


        carouselList.push({id:"0004", price:140, title: "Nintendo Switch met Picofly MOD chip", subtitle: "Koop wat u ziet op de foto's of stuur me een bericht met de opties die u wenst:	", items: carouselitems});

        carouselitems = [];
        carouselitems.push({
            content: <div onClick={() => { }} style={{ cursor: "pointer" }}>
                <div style={{ width: PageWidth, maxWidth: PageWidth, minHeight: 300, backgroundSize: "contain", backgroundImage: `url(${process.env.PUBLIC_URL}/assets/Products/4/1.webp?v=1)` }} className={styles.mainSelectedSetLogo} />
            </div>

        });
        carouselitems.push({
            content: <div onClick={() => { }} style={{ cursor: "pointer" }}>
                <div style={{ width: PageWidth, maxWidth: PageWidth, minHeight: 300, backgroundSize: "contain", backgroundImage: `url(${process.env.PUBLIC_URL}/assets/Products/4/2.webp?v=1)` }} className={styles.mainSelectedSetLogo} />
            </div>

        });
        carouselitems.push({
            content: <div onClick={() => { }} style={{ cursor: "pointer" }}>
                <div style={{ width: PageWidth, maxWidth: PageWidth, minHeight: 300, backgroundSize: "contain", backgroundImage: `url(${process.env.PUBLIC_URL}/assets/Products/4/3.webp?v=1)` }} className={styles.mainSelectedSetLogo} />
            </div>

        });

        carouselList.push({id:"0005", price:140, title: "Nintendo Switch met Picofly MOD chip", subtitle: "Koop wat u ziet op de foto's of stuur me een bericht met de opties die u wenst:	", items: carouselitems});

        return carouselList;
    }

    return (
        carouselList?.length ?
            <div>
                <div>
                    <Stack horizontalAlign='center'>
                        {carouselList.map(carouselI => {
                            return <div className={`${styles.cPanel} ${styles.setLogoMenuWelcome}`} style={{ backgroundColor: "white" }}>
                                <div style={{ maxWidth: (PageWidth / 2) - 24, width: "100%", minWidth: ((PageWidth / 2) - 24) > 350 ? ((PageWidth / 2) - 24) : 350 }} >
                                    <MainCarouselComponent isDev={false} switchSpeed={20} animationsEnabled={false} items={carouselI.items} maxWidth={((PageWidth / 2) - 24) > 380 ? ((PageWidth / 2) - 24) : 350} />
                                </div>

                                <div style={{ maxWidth: (PageWidth / 2) - 24, minWidth: ((PageWidth / 2) - 24) > 350 ? ((PageWidth / 2) - 24) : 350, paddingLeft: ((PageWidth / 2) - 24) > 350 ? 20 : 5, height: "stretch" }}>
                                    <Stack verticalAlign='center' style={{ height: "stretch" }}>
                                        <table>
                                            <tr>
                                                <td>
                                                    <h2>{carouselI.title}</h2>
                                                </td>
                                                <td></td>
                                                <td>
                                                    <h2>€{carouselI.price},-</h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    {carouselI.subtitle}
                                                </td>
                                                <td></td>
                                                <td></td>
                                            </tr>
                                            <tr>
                                                <td>&nbsp;</td>
                                                <td></td>
                                                <td></td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    • Nintendo Switch Dock
                                                </td>
                                                <td></td>
                                                <td>
                                                    €20,-
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    • Nintendo Switch Charger
                                                </td>
                                                <td></td>
                                                <td>
                                                    €10,-
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    • 64 GB micro SD
                                                </td>
                                                <td></td>
                                                <td>
                                                    €20,-
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    • 128 GB micro SD
                                                </td>
                                                <td></td>
                                                <td>
                                                    €30,-
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    • 256 GB micro SD
                                                </td>
                                                <td></td>
                                                <td>
                                                    €40,-
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    • Nintendo pro controller
                                                </td>
                                                <td></td>
                                                <td>
                                                    €20,-
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    • Off brand pro controller
                                                </td>
                                                <td></td>
                                                <td>
                                                    €10,-
                                                </td>
                                            </tr>
                                        </table>
                                        <br />
                                        <Stack horizontal horizontalAlign='end' verticalAlign='end' style={{ height: "100%" }}>
                                            <a href={"mailto:switchmodshop@proton.me?subject=Switch mod, id:"+carouselI.id}>Vragen of kopen? Click hier</a>
                                        </Stack>
                                    </Stack>
                                </div>
                            </div>
                        })}

                    </Stack>
                </div>
            </div> : <></>
    );
}

export default WelcomeComponent;